"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactCollapse = _interopRequireDefault(require("react-collapse"));

var _index = require("./index.styles");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var createRandomId = function createRandomId() {
  return "r".concat(Math.random().toString(36).slice(8));
};

var Collapsible = function Collapsible(_ref) {
  var title = _ref.title,
      initiallyOpen = _ref.initiallyOpen,
      animate = _ref.animate,
      onToggle = _ref.onToggle,
      children = _ref.children,
      buttonLabels = _ref.buttonLabels;

  var _useState = (0, _react.useState)(initiallyOpen),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      id = _useState4[0],
      setId = _useState4[1];

  var toggle = (0, _react.useCallback)(function () {
    setIsOpen(!isOpen);
    onToggle(!isOpen);
  }, [setIsOpen, isOpen, onToggle]);
  (0, _react.useEffect)(function () {
    setId(createRandomId());
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_index.Wrapper, {
    animate: animate,
    "data-testid": "collapsible"
  }, /*#__PURE__*/_react["default"].createElement(_index.CollapsibleButton, {
    "aria-haspopup": "true",
    "aria-expanded": isOpen,
    "aria-controls": id,
    onClick: toggle
  }, /*#__PURE__*/_react["default"].createElement(_index.CollapsibleTitle, null, title), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_index.CollapsibleChevron, {
    animate: animate,
    title: "".concat(isOpen ? buttonLabels.open : buttonLabels.close, " ").concat(title),
    flipHorizontal: isOpen
  }))), /*#__PURE__*/_react["default"].createElement(_reactCollapse["default"], {
    isOpened: isOpen
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: id
  }, children)));
};

Collapsible.propTypes = {
  title: _propTypes.node.isRequired,
  initiallyOpen: _propTypes.bool,
  animate: _propTypes.bool,
  onToggle: _propTypes.func,
  children: _propTypes.node.isRequired,
  buttonLabels: (0, _propTypes.shape)({
    open: _propTypes.string,
    close: _propTypes.string
  })
};
Collapsible.defaultProps = {
  initiallyOpen: false,
  animate: true,
  onToggle: function onToggle(isOpen) {},
  buttonLabels: {
    open: 'Open',
    close: 'Sluit'
  }
};
var _default = Collapsible;
exports["default"] = _default;